import { render } from "./AuthorizationDetail.vue?vue&type=template&id=48bd80de&scoped=true"
import script from "./AuthorizationDetail.js?vue&type=script&lang=js&external"
export * from "./AuthorizationDetail.js?vue&type=script&lang=js&external"

import "./AuthorizationDetail.scss?vue&type=style&index=0&id=48bd80de&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48bd80de"]])

export default __exports__